import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { ModalWrapper } from '../modal-wrapper'
import { useDisconnect } from 'wagmi'

import { useStyles } from './styles'
import { IProfileUserForm, IUserWalletBase } from 'src/types'
import { UserWalletsDetailsModalItem } from './user-wallets-details-modal-item.component'
import { HelperWrapper } from '../helper-wrapper'
import { UserWalletsDetailsMobile } from './user-wallet-details-mobile-view'
import { useFormikContext } from 'formik'

interface IProps {
  open: boolean
  handleClose: () => void
  onDefaultWalletChange: (address: string) => void
  wallets: Omit<IUserWalletBase, 'privateKey'>[]
}

export const UserWalletsDetailsModal = ({
  open,
  handleClose,
  wallets,
  onDefaultWalletChange,
}: IProps) => {
  const classes = useStyles()
  const theme = useTheme()

  const { values, setFieldValue } = useFormikContext<IProfileUserForm>()

  const { disconnect } = useDisconnect()

  // const { mutateAsync: disconnectWallet } = useDisconnectUserSelfManagedWallet()
  // const { mutateAsync } = useSetCustodialWalletActive()

  const isLaptop = useMediaQuery(theme.breakpoints.up('laptop'))
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  const handleMakeWalletActive = async (address: string) => {
    disconnect()
    // await mutateAsync(walletId)
    setTimeout(() => {
      onDefaultWalletChange(address)
    }, 300)

    handleClose()
  }

  const handleDisconectSelfManagedWallet = async (address: string) => {
    const updatedWallets = values.wallets.filter(
      (wallet) => wallet.address.toLowerCase() !== address.toLowerCase(),
    )
    setFieldValue('wallets', updatedWallets)
  }

  return (
    <ModalWrapper className={classes.modalWrapper} open={open} onClose={handleClose}>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          gap: '20px',
          width: isLaptop ? '800px' : '100%',
          maxWidth: '90vw',
          flexDirection: 'column',
          justifyContent: 'space-between',
          pt: '15px',
          maxHeight: '75dvh',
          overflowY: 'auto',
        }}
      >
        {isTablet ? (
          <UserWalletsDetailsMobile
            wallets={wallets}
            handleMakeWalletActive={handleMakeWalletActive}
            handleDisconectSelfManagedWallet={handleDisconectSelfManagedWallet}
          />
        ) : (
          <TableContainer
            sx={{
              width: '100%',
              px: '18px',
              overflowX: 'auto',
            }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <HelperWrapper t="user-wallet-address-label" />
                  </TableCell>
                  <TableCell align="center">
                    <HelperWrapper t="user-wallet-scans-label" />
                  </TableCell>
                  <TableCell align="center">
                    <HelperWrapper t="user-wallet-trai-balance-label" />
                  </TableCell>
                  <TableCell align="center">
                    <HelperWrapper t="user-wallet-eth-balance-label" />
                  </TableCell>
                  <TableCell>
                    <HelperWrapper t="user-wallet-type-label" />
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {wallets.map((wallet) => (
                  <UserWalletsDetailsModalItem
                    key={wallet.address}
                    wallet={wallet}
                    handleMakeWalletActive={handleMakeWalletActive}
                    handleDisconectSelfManagedWallet={handleDisconectSelfManagedWallet}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </ModalWrapper>
  )
}
